import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';

import { APIConfig } from 'src/config';
import {
  FEATURE_INHIBIT_COMMUNITY_TRADES,
  FEATURE_INHIBIT_CONTRACTED_TRADES,
  FEATURE_INHIBIT_NOMINATED_TRADES,
} from 'src/util/constants';

/**
 * Disabled filter placeholder component for the trade list table
 * @returns {React.ReactComponentElement} - TradeListDisabledFilterPlaceholder component
 */
function TradeListDisabledFilterPlaceholder() {
  return (
    <>
      <ButtonGroup className="me-2 mb-2">
        <Button size="sm" className="btn btn-darken" style={{ minWidth: '2.5rem' }} disabled aria-hidden="true" />
      </ButtonGroup>
      <ButtonGroup className="me-2 mb-2">
        <Button size="sm" className="btn btn-darken" style={{ minWidth: '3rem' }} disabled aria-hidden="true" />
        <Button size="sm" className="btn btn-darken" style={{ minWidth: '3rem' }} disabled aria-hidden="true" />
      </ButtonGroup>

      <ButtonGroup className="me-2 mb-2">
        {!APIConfig().feature(FEATURE_INHIBIT_CONTRACTED_TRADES) && (
          <Button size="sm" className="btn btn-darken" style={{ minWidth: '6rem' }} disabled aria-hidden="true" />
        )}
        {!APIConfig().feature(FEATURE_INHIBIT_NOMINATED_TRADES) && (
          <Button size="sm" className="btn btn-darken" style={{ minWidth: '6.5rem' }} disabled aria-hidden="true" />
        )}
        {!APIConfig().feature(FEATURE_INHIBIT_COMMUNITY_TRADES) && (
          <Button size="sm" className="btn btn-darken" style={{ minWidth: '5.5rem' }} disabled aria-hidden="true" />
        )}
        <Button size="sm" className="btn btn-darken" style={{ minWidth: '8.5rem' }} disabled aria-hidden="true" />
      </ButtonGroup>
    </>
  );
}

export default TradeListDisabledFilterPlaceholder;
